import lazyWithRetry from 'tools/lazyWithRetry';

const TaxZoneListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "taxZoneListPage" */
	'../../pages/Invoice/TaxZone/TaxZoneListPage'));

export default [
	{
		component: TaxZoneListPage,
		exact: true,
		path: '/taxZones',
	},
];